export default axios => ({
  getContracts: ({ projectId, payload }) => axios.get(`projects/${projectId}/ast/contracts`, payload).then(({ data }) => data.data),
  getContractsCompact: ({ projectId, payload }) => axios.get(`projects/${projectId}/ast/contracts/compact`, payload).then(({ data }) => data.data),

  getContractById: ({ projectId, contractId, payload }) => axios.get(`projects/${projectId}/ast/contracts/${contractId}`, payload).then(({ data }) => data.data),
  
  getContractWorksByContract: ({ projectId, contractId, payload }) => axios.get(`projects/${projectId}/ast/contracts/${contractId}/works`, payload).then(({ data }) => data.data),
  getContractWorksByTask: ({ projectId, contractId, taskId, payload }) => axios.get(`projects/${projectId}/ast/contracts/${contractId}/tasks/${taskId}/works`, payload).then(({ data }) => data.data),

  getWorkFactsByContract: ({ projectId, contractId, payload }) => axios.get(`projects/${projectId}/ast/contracts/${contractId}/work-facts`, payload).then(({ data }) => data.data),
  getWorkFactsByTask: ({ projectId, contractId, taskId, payload }) => axios.get(`projects/${projectId}/ast/contracts/${contractId}/tasks/${taskId}/work-facts`, payload).then(({ data }) => data.data),

  getAstReport: ({ projectId, payload }) => axios.post(`projects/${projectId}/ast/report`, payload, {
    responseType: 'blob'
  }),

  setWorksEvolve: ({ projectId, payload }) => axios.post(`projects/${projectId}/ast/works/evolve`, payload)
})
